import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import React from "react";
import ReactDOM from "react-dom";
import { createStore } from "redux";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { composeWithDevTools } from "redux-devtools-extension";
// import core from 'core';
import { CookiesProvider } from "react-cookie";

import App from "./App/index";
import * as serviceWorker from "./serviceWorker";
import reducer from "./store/reducer";
import config from "./config";
import { checkIpAllowed, BlockedScreen } from "./ipGuard";

const store = createStore(reducer, composeWithDevTools());

const app = (
    <Provider store={store}>
        <BrowserRouter basename={config.basename}>
            <CookiesProvider>
                <App />
            </CookiesProvider>
        </BrowserRouter>
    </Provider>
);

// 허용 IP 확인 후 렌더 — 목록 외 접속은 안내 화면만 표시 (src/ipGuard.js)
const rootEl = document.getElementById("root");
checkIpAllowed().then(({ allowed, ip }) => {
    ReactDOM.render(allowed ? app : <BlockedScreen ip={ip} />, rootEl);
});

serviceWorker.unregister();
